import https from "@/units/https";
import QS from "qs";
import { apiPath } from '@/units/config';

const request = (config) => {
  config = config || {}
  config.params = config.params || {}
  config.data = config.data || {}

  if (config.url[0] !== '/') {
    config.url = apiPath + config.url;
  }

  // 不在前端自动追加 tenant_id；由后端根据登录态/上下文决定租户

  if ((config.method || '').toUpperCase() === 'POST') {
    // form: true 时使用 x-www-form-urlencoded，兼容 ThinkPHP 从 $_POST 读取 activity_id 等字段（JSON 体部分环境未注入 param）
    const payload = config.form ? QS.stringify(config.data) : config.data;
    const headers = config.form ? { 'Content-Type': 'application/x-www-form-urlencoded' } : {};
    return https.post(config.url, payload, { params: config.params, headers });
  }

  // axios: get(url, config)
  return https.get(config.url, { params: config.params });
};

export default request;
